import React from 'react';
import {
  StyledContentHeader,
  StyledDivider,
  StyledIssueEventTitle,
  StyledSummaryCard,
  StyledSummaryCardTitle,
} from '@src/pages/workflow/components/Validation/Flow/styled';

import ErrorIcon from '@icons/error_cross.svg';
import SuccessIcon from '@icons/green_checkmark.svg';
import Icon from '@ant-design/icons';
import { Tooltip } from 'antd';

const SummaryCard: React.FC<{ summaryData: any; dimension: any }> = ({
  summaryData,
  dimension,
}) => {
  const issues = summaryData?.issues || [];
  const coverage = summaryData?.coverage || [];

  const displayNameMap = {
    initial_event: 'Initial Event',
    complete_event: 'Complete Event',
    event: 'Event',
  };

  return (
    <div style={{ width: '30%' }}>
      <StyledContentHeader>Summary</StyledContentHeader>
      <StyledSummaryCard>
        <StyledSummaryCardTitle>Platform Coverage</StyledSummaryCardTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {coverage.map((item: any) => {
            return (
              <div
                key={item.app_platform}
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                {item.is_covered ? (
                  <Tooltip
                    title={'The configured event(s)(mapping rule) has coverage on this platform.'}
                  >
                    <Icon component={SuccessIcon} />
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={'The configured event(s) (mapping rule) are missing on this platform.'}
                  >
                    <Icon component={ErrorIcon} />
                  </Tooltip>
                )}{' '}
                {item.app_platform}
              </div>
            );
          })}
        </div>
        <StyledDivider />
        <div>
          <StyledSummaryCardTitle>Issues</StyledSummaryCardTitle>
          {issues.length ? (
            <div>
              {issues.map((issue: any) => {
                return (
                  <div key={issue.event_field} style={{ marginBottom: '24px' }}>
                    <div style={{ marginBottom: '24px' }}>
                      <StyledIssueEventTitle>
                        {displayNameMap[issue.event_field] || issue.event_field}{' '}
                      </StyledIssueEventTitle>{' '}
                      is missing on below Platform/{dimension?.display_name} :
                    </div>
                    <ul style={{ paddingLeft: '24px', margin: 0 }}>
                      {issue.missing_fields.map((missingField: any) => {
                        const fields = missingField.split(' ');
                        const platformName = fields.shift();
                        const dimension = fields.join(' ');
                        return (
                          <li key={missingField}>
                            {platformName} / {dimension}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </StyledSummaryCard>
    </div>
  );
};

export default SummaryCard;
